import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePrefersReducedMotion } from "@cinch-nx/shared-ui";
import { Box, Skeleton } from "@mui/material";
import cx from "classnames";
import styles from "./hub-card-skeleton.module.css";
export var HubCardSkeleton = function(param) {
    var featured = param.featured, _hasDate = param.hasDate, hasDate = _hasDate === void 0 ? false : _hasDate;
    var prefersReducedMotion = usePrefersReducedMotion();
    return /*#__PURE__*/ _jsxs(Box, {
        className: cx(styles.root, _define_property({}, styles.featured, featured)),
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                sx: {
                    marginRight: "16px"
                },
                animation: prefersReducedMotion ? false : "wave",
                variant: "rectangular",
                width: featured ? 400 : 250,
                height: featured ? 253 : 158
            }),
            /*#__PURE__*/ _jsxs(Box, {
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "text",
                        height: 24,
                        width: hasDate ? 400 : 125
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "text",
                        height: 24,
                        width: hasDate ? 125 : 400
                    })
                ]
            })
        ]
    });
};
